import styled , {css} from 'styled-components'

function trOpacity(){
    let styles = '';

    for (let i = 1; i < 31; i +=1){
        styles +=`
            :nth-child(${i}){
                opacity: 0;
                animation: bgopa .5s ${0.03*i}s forwards;
            }
        `
    }
    return css`${styles}`;
}


export const Styles = styled.div`
  /* padding: 1rem; */
  /* padding-bottom: 100px; */
  /* border: black solid; */
  position: relative;
  width: 100%;
    transition: .5s;
    display: block;

    @keyframes bgopa{
        0%{opacity: 0;}
        100%{opacity: 1;}
    }

    button{
        margin: 5px;
        padding: 5px;
        padding-left: 7px;
        padding-right: 7px;
        border: .5px solid rgba(0,0,0,0.2);
        border-radius: 12px;
        color: white;
        cursor: pointer;
        background-color: transparent;
        transition: .2s;
        :hover{
            background-color: rgba(0,0,0,0.1);
        }
        :active{
            background-color: rgba(0,0,0,0.2);
        }
    }

    div{
        /* margin: 10px; */
        span{
            display: inline-flex;
            align-items: center;
            justify-content: center;
            > input[type="checkbox"]{
                    position: absolute;
                    opacity: 0;
                    
                    :checked + label{
                        border: rgba(46, 88, 142, 1) 1px solid;
                        border-radius: 5px;
                        padding: 5px 10px;
                        margin: 10px;
                        background-color: rgba(46, 88, 142, 1);
                        cursor: pointer;
                        transition: .3s;
                    }
                    > label{
                        border: rgba(46, 88, 142, 1) 1px solid;
                        border-radius: 5px;
                        padding: 5px 10px;
                        margin: 10px;
                        cursor: pointer;
                        transition: .3s;
                    }
                }
                
                label{
                    border: rgba(46, 88, 142, 1) 1px solid;
                    border-radius: 5px;
                    padding: 5px 10px;
                    margin: 10px;
                    cursor: pointer;

                    transition: .3s;
                    
                }
        }
    }

  
  #table-div{
      text-align: left;
        #table-input{
            width: 250px;
            input{
                    border: 1px solid grey !important;
                    border-radius: 5px;
                    padding: 2px;
                    color: black;
                    width: 300px;
                    background-color:rgba(255, 255, 255, 1);
                    user-select:none;
                    outline: none;
                }
            
        }
        .table-filter{
                display: block;
                text-align: center;
                margin-top: 20px;
                margin-bottom: 20px;
                > input[type="radio"]{
                    position: absolute;
                    opacity: 0;
                    
                    :checked + label{
                        display: inline-block;
                        padding: 5px 10px;
                        margin: 10px;
                        /* background-color: rgba(46, 88, 142, 1); */
                        cursor: pointer;
                        color: rgba(253,134,18, 1);
                        font-weight: bold;
                        font-size: 1.05rem;
                        transition: .0s;
                        position: relative;
                        width: calc(100% / 7);
                        padding: 0;
                        margin: 0;
                        margin-top: 10px;
                        margin-bottom: 10px;

                        :after{
                            position: absolute;
                            left: 0;
                            width: 100%;
                            border-bottom: rgba(253,134,18, .8) 2px solid;
                            border-radius: 5px;
                            content: "";
                            display: block;
                            /* width: 60px; */
                            margin-top: 5px;
                        }
                    }
                    > label{
                        position: relative;
                        display: inline-block;
                        border-radius: 5px;
                        padding: 5px 10px;
                        margin: 10px;
                        cursor: pointer;
                        font-size: 1.05rem;
                        transition: .0s;
                        width: calc(100% / 7);
                        padding: 0;
                        margin: 0;
                        margin-top: 10px;
                        margin-bottom: 10px;
                        
                    }
                }
                
                label{
                    display: inline-block;
                    /* border: rgba(46, 88, 142, 1) 1px solid; */
                    border-radius: 5px;
                    padding: 5px 10px;
                    margin: 10px;
                    cursor: pointer;
                    font-size: 1.05rem;
                    transition: .0s;
                    width: calc(100% / 7);
                    padding: 0;
                    margin: 0;
                    margin-top: 10px;
                    margin-bottom: 10px;

                    
                }
            }

        
        table {
            /* animation: bgopa .5s forwards; */
            border-spacing: 0;
            user-select: text;
            position: absolute;
            margin-top: 20px !important;
            margin-bottom: 20px !important;
            width: 100%;
            
            border-collapse: collapse;

            /* * {
                outline: none;
                *:after, *:before{
                    box-sizing: border-box;
                -moz-box-sizing: border-box;
                }
            } */

            /* tr {
                :last-child {
                    td {

                    border-bottom: 0;
                    }
                }
            } */

            thead{
                user-select: none;
                border: none;
                tr{  
                    :first-child{
                        
                        font-size:1.1rem;
                        /* background-color: rgba(144, 45, 19, 1); */
                        /* background-color: rgba(223, 142, 19, 1); */
                    }
                    
                }
            }  

            tbody{
                tr{
                    
                    /* opacity: 0; */
                    /* ${trOpacity()} */

                    border: .5px solid rgba(0,0,0,0.2);
                    border-radius: 5px;
                    min-height: 80px;
                    background-color: white;
                    height: 80px;

                    /* box-sizing: border-box;
                    padding: 5px; */
                    
                    :nth-child(2){
                        
                    }
                    :hover{
                        background-color: rgba(0, 0, 0, 0.005);
                        transition: .1s;
                    }

                    

                    td{
                        position: relative;
                        display: inline-flex;
                        justify-content: center;
                        align-items: center;
                        :first-child{
                            justify-content: flex-start;
                        }
                        >a{
                            position: absolute;
                            padding: 0;
                            top: 0;
                            left: 0;
                            width: 100%;
                            height: 100%;
                            text-decoration: none;
                            color: whitesmoke;
                        }
                    }
                    
                }
                td{
                    /* >div{
                        display: flex;
                        justify-content:center;
                        >button{
                            
                        }
                    } */

                    padding-bottom: 20px;
                    padding-top: 20px;
                    padding-left: 5px;

                    .table-position{
                        /* background-color: green; */
                        display: inline-flex;
                        font-size: 0.8rem;
                        border: .5px solid rgba(0,0,0,0.2);
                        border-radius: 12px;
                        box-sizing: border-box;
                        padding: 5px;
                        padding-right:7px;
                        padding-left: 7px;
                        margin: 5px;
                        /* >div{
                            display: inline-flex;
                            border: 1px black solid;
                        } */
                    }

                    >a{
                        text-decoration: none;
                        color: whitesmoke;
                    }
                    font-size: 0.9rem;
                    :first-child{
                        width: 35%;
                        
                        img{
                            display: inline-block;
                            width: 60px;
                            height: 60px;
                            border-radius: 50px;
                            background-position-x:50%;
                            background-position-y:50%;
                            background-size: cover; 
                            vertical-align: top;
                        }
                        >div{
                            height: 60px;
                            display: inline-block;
                            align-items: center;
                            justify-content: center;
                            box-sizing: border-box;
                            padding-left: 5px;
                            vertical-align: top;
                            >div{
                                height: 40%;
                                display: flex;
                                align-items: center;
                                width: 100%;
                                font-size: 1rem;
                                :nth-child(2), :nth-child(3){
                                    height: 30%;
                                    /* margin-bottom: 3px; */
                                    font-size: 0.8rem;
                                }
                            }
                        }
                    }
                    :nth-child(2){
                        width: 20%;
                    }
                    :nth-child(3){
                        width: 10%;
                    }
                    :nth-child(4){
                        width: 20%;
                    }
                    :nth-child(5){
                        width: 10%;
                        font-size: .75rem;
                    }
                }
            }

            th,
            td {
                span{
                    user-select: none;
                }

                input{
                    /* background-color: transparent; */
                    border: 1px solid grey !important;
                    border-radius: 5px;
                    padding: 2px;
                    color: white;
                    width: 100%;
                    background-color:rgba(255, 255, 255, .05);
                    /* max-width: 120px; */
                }
                select{
                    background-color:rgba(255, 255, 255, .05);
                    border: 1px solid grey !important;
                    border-radius: 5px;
                    color: white;
                    padding: 2px;
                    width: 100%;
                    cursor: pointer;

                    option{
                        border: none;
                        background-color: rgba(0, 0, 0, 0.8);
                        transition: .2s;
                    }
                }
            }
    }
    }
`